import {
  ApiResponse,
  BaseAPI,
  CardPagePaymentResult,
  Currency,
  EpaymentApi,
} from '../../generated-sources/epayment-internal-api';

export class FakeEpaymentApi extends BaseAPI implements EpaymentApi {
  public async getPaymentDetailsRaw(): Promise<ApiResponse<CardPagePaymentResult>> {
    const result: CardPagePaymentResult = {
      merchant: {
        merchantSerialNumber: '123456',
        name: 'Merchant AS',
      },
      transaction: {
        amount: {
          currency: Currency.Nok,
          value: 1000,
        },
        returnUrl: 'https://vipps.no',
      },
      expireTime: 5000,
      peToken: 'success',
    };
    return {
      raw: new Response(),
      value: async () => result,
    };
  }

  public async getPaymentDetails(): Promise<CardPagePaymentResult> {
    const apiResponse = await this.getPaymentDetailsRaw();
    return apiResponse.value();
  }

  async abortCardPayment(): Promise<void> {
    await this.abortCardPaymentRaw();
    return Promise.resolve(undefined);
  }

  async abortCardPaymentRaw(): Promise<ApiResponse<void>> {
    return { raw: new Response(), value: () => Promise.resolve() };
  }
}
